import { render, staticRenderFns } from "./holiday.vue?vue&type=template&id=f86bee82&scoped=true&"
import script from "./holiday.ts?vue&type=script&lang=ts&"
export * from "./holiday.ts?vue&type=script&lang=ts&"
import style0 from "./holiday.scss?vue&type=style&index=0&id=f86bee82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86bee82",
  null
  
)

export default component.exports